import './App.css';
import Whiteboard from "./Whiteboard";

function App() {
  return <Whiteboard />;
}

export default App;